export default {
  // 右鍵菜單選項
  viewdetails: "展開詳情",
  noteNode: "備註節點",
  copyAddress: "複製地址",
  newCanvas: "新建畫布",
  tagSettings: "標籤設置",
  addTag: "添加標籤",
  modifyTag: "修改標籤",
  deleteTag: "刪除標籤",
  joinSurvey: "加入調證",
  ordinarySurvey: "普通調證",
  keySurvey: "重點調證",
  joinMonitoring: "加入監控",
  joinBoard: "加入看板",
  exchangeExpansion: "交易所擴展",
  aiModel: "AI模型：",
  firstFeeTraceability: "首筆手續費追溯",
  multilayerTraceability: "多層追溯",
  transactionPathAnalysis: "交易路徑分析",
  addToStart: "添加到起點",
  addToEnd: "添加到終點",
  relatedFeeModel: "關聯手續費模型",
  tornadoModel: "龍捲風模型",
  deleteNode: "刪除節點",
  newOldStopModel: "新啟舊停模型",
  singleChannelModel: "單通道中轉模型",

  // 批量操作
  batchDeleteNode: "批量删除节点",
  batchNote: "批量備註",
  batchCopy: "批量複製",
  batchAddTag: "批量添加標籤",
  batchJoinSurvey: "批量加入調證",
  batchJoinBoard: "批量加入看板",
  directAssociation: "直接關聯",
  batchExpansion: "批量擴展",
  batchQueryBalance: "批量查詢餘額",
  commonTradingCounterpart: "共同交易對手",

  // 快捷鍵
  altV: "alt+v/⌥+v",
  ctrlC: "ctrl+C/⌘+C",
  altG: "alt+g/⌥+g",
  ctrlM: "ctrl+M/⌘+M",
  ctrlR: "ctrl+R/⌘+R",
  enter: "enter/return",

  // 錯誤提示
  cannotSelectBothTypes: "不能同時選擇調證節點和普通節點",
  aggregateNodeNotSupported: "聚合點不支持該操作！",
  notSupportMultipleTypes: "不支持同時操作多個類型的節點",
  platformException: "平台異常",
  tip: "提示",
  noRelatedData: "很抱歉，關聯查詢結果中沒有找到相關數據",
  noMoreBranches: "已無更多分支或該數據源配置中暫無結果",
  aggregationPointNotSupported: "跨鏈平台節點不支持操作，請在跨鏈交易詳情頁面進行跨鏈追蹤",
  mixPlatformNodeNotSupported: "混幣平台節點不支持操作，請在混幣交易詳情頁面進行混幣追蹤",

  // 保存相關
  saveInfo: "保存信息",
  modifyInfo: "修改信息",

  // vis-network 本地化
  edit: "編輯",
  del: "刪除當前節點或關係",
  back: "返回",
  addNode: "添加節點",
  addEdge: "添加連線",
  editNode: "編輯節點",
  editEdge: "編輯連線",
  addDescription: "點擊空白處可添加節點",
  edgeDescription: "點擊某個節點拖拽連線可連接另一個節點",
  editEdgeDescription: "可拖拽連線改變關係",
  createEdgeError: "無法將邊連接到集群",
  deleteClusterError: "無法刪除集群.",
  editClusterError: "無法編輯群集'",
};
